// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__ZY43b","status":"Form_status__Orz8r","error":"Form_error__EJH8p","success":"Form_success__G2rcC","check":"Form_check__h1IgI"};